/* ============================================================
   MagicBeez — Compteur count-up (ROI / chiffres clés)
   Vanilla, defer, IntersectionObserver, idempotent, reduced-motion.
   Usage : <span data-mb-counter="16000" data-prefix="" data-suffix=" €"
                 data-duration="1600" data-decimals="0" data-sep=" "></span>
   ============================================================ */
(function () {
  if (window.__mbCounterInit) return;
  window.__mbCounterInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function format(value, el) {
    var dec = parseInt(el.getAttribute('data-decimals'), 10) || 0;
    var prefix = el.getAttribute('data-prefix') || '';
    var suffix = el.getAttribute('data-suffix') || '';
    var sep = el.getAttribute('data-sep');
    var s = value.toFixed(dec);
    if (sep) {
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      s = parts.join('.');
    }
    return prefix + s + suffix;
  }

  function animate(el) {
    if (el.__mbDone) return;
    el.__mbDone = true;
    var to = parseFloat(el.getAttribute('data-mb-counter')) || 0;
    var from = parseFloat(el.getAttribute('data-from')) || 0;
    var dur = parseInt(el.getAttribute('data-duration'), 10) || 1600;

    if (reduce || dur <= 0) { el.textContent = format(to, el); return; }

    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
      el.textContent = format(from + (to - from) * eased, el);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var els = scope.querySelectorAll('[data-mb-counter]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, animate);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animate(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  // Re-init dans l'éditeur de thème
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
